import { SectionConfig } from "../../types";
import { selectTargetFilter } from "../selectors";

const config: SectionConfig = {
  section: "targetFilter",
  titleKey: "filters.target",
  selector: selectTargetFilter,
  properties: {
    filterPolicyId: {
      label: "filterPolicy.toggle",
      format: { resolve: "filterPolicy" },
    },
    // The form has no defaults object for these: EmailFlowOptions reads
    // `filter?.<field>` straight into a switch, so an untouched one is false.
    cancelShortCodeEnabled: {
      label: "cancelShortCodeEnabled",
      format: "boolean",
      default: false,
    },
    onlyManagedAccounts: {
      label: "onlyManagedAccounts",
      format: "boolean",
      default: false,
    },
    triggerOnShortCode: {
      label: "triggerOnShortCode",
      format: "boolean",
      default: false,
    },
    exclusions: {
      label: "confirmRuleUpdates.targetFilter.fromToExclusions",
      format: { resolve: "fromTo" },
      getItemKey: item => JSON.stringify(item),
    },
    // The engine reads a rule without the field as ANYONE, so a rule saved
    // before the option existed is not reported as changed.
    excludeMatching: {
      label: "targetFilter.excludeMatching.label",
      format: {
        enum: {
          ANYONE: "targetFilter.excludeMatching.options.ANYONE",
          ALL: "targetFilter.excludeMatching.options.ALL",
        },
      },
      default: "ANYONE",
    },
    filterBySender: {
      label: "archivingFilter.filterBySender.label",
      format: "boolean",
    },
  },
};

export default config;
